import { DeductionDocumentProps } from "@/core/entities/deduction";
import { DateService } from "@/core/services";
import { isSignedUrlExpired } from "@/core/utils/SignedURL.Utils";
import { DateAdapter } from "@/infrastructure/adapters/dayJs";

export type PromotionSourceDocumentProps = Omit<DeductionDocumentProps, "documentType" | "documentTypeKey" | "isProcessed" | "deletable">;

export class PromotionSourceDocument implements PromotionSourceDocumentProps {
    private readonly _id: number;
    private readonly _fileName: string;
    private readonly _fileSize: number;
    private readonly _createdAt: string;
    private readonly _updatedAt: string;
    private readonly _fileMimeType: string;
    private readonly _fileDisplayName: string;
    private readonly _filePath: string;
    private _signedUrl: string;

    constructor(props: PromotionSourceDocumentProps) {
        this._id = props.id;
        this._fileName = props.fileName;
        this._fileSize = props.fileSize;
        this._createdAt = props.createdAt;
        this._updatedAt = props.updatedAt;
        this._fileMimeType = props.fileMimeType;
        this._fileDisplayName = props.fileDisplayName;
        this._filePath = props.filePath;
        this._signedUrl = props.signedUrl;
    }

    public get id(): number {
        return this._id;
    }

    public get fileName(): string {
        return this._fileName;
    }

    public get fileSize(): number {
        return this._fileSize;
    }

    public get createdAt(): string {
        return this._createdAt;
    }

    public get updatedAt(): string {
        return this._updatedAt;
    }

    public createdAtFormatted(format: string): string {
        return new DateService(new DateAdapter()).format(this._createdAt, format);
    }

    public get fileMimeType(): string {
        return this._fileMimeType;
    }

    public get fileDisplayName(): string {
        return this._fileDisplayName;
    }

    public get filePath(): string {
        return this._filePath;
    }

    public set signedUrl(signedUrl: string) {
        this._signedUrl = signedUrl;
    }

    public get signedUrl(): string {
        return this._signedUrl;
    }

    public get isExpired(): boolean {
        return isSignedUrlExpired(this._signedUrl);
    }

    public get fileExtension(): string {
        return this._fileName.split(".").pop() ?? "";
    }

}